import type { SVGProps } from 'react';

export const ChevronRightIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M8.34524 20.7483C8.03587 21.0857 7.53615 21.0836 7.22901 20.7438C6.92209 20.404 6.92389 19.8551 7.23312 19.5178L14.095 12.0365L7.2804 4.47619C6.97451 4.13586 6.97707 3.58678 7.28657 3.25019C7.59628 2.91377 8.09615 2.91722 8.4028 3.25696L15.7601 11.4201C15.7632 11.4235 15.7673 11.4269 15.7704 11.4303C15.9619 11.6424 16.0341 11.9365 15.9852 12.2092C15.9563 12.3711 15.8837 12.5249 15.7704 12.6507C15.7689 12.6523 15.7678 12.6546 15.7663 12.6563L8.34524 20.7483Z" />
  </svg>
);
